/* IP contact page: a copy button next to each email address (the page body says "copy the address if the mail app does not open"). */
(function() {
  'use strict';
  var links = document.querySelectorAll('a.ip-contact__email[href^="mailto:"]');
  if (!links.length) return;

  function fallbackCopy(text) {
    var area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (error) { ok = false; }
    document.body.removeChild(area);
    return ok;
  }

  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).then(function() { return true; }, function() { return fallbackCopy(text); });
    }
    return Promise.resolve(fallbackCopy(text));
  }

  Array.prototype.forEach.call(links, function(link) {
    var address = decodeURIComponent(link.getAttribute('href').slice('mailto:'.length).split('?')[0]);
    if (!address) return;
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'ip-contact__copy';
    button.textContent = 'アドレスをコピー';
    var status = document.createElement('span');
    status.className = 'ip-contact__copy-status';
    status.setAttribute('role', 'status');
    var timer;
    button.addEventListener('click', function() {
      copy(address).then(function(ok) {
        status.textContent = ok ? 'コピーしました' : 'コピーできませんでした。アドレスを長押ししてコピーしてください';
        clearTimeout(timer);
        timer = setTimeout(function() { status.textContent = ''; }, 4000);
      });
    });
    link.insertAdjacentElement('afterend', status);
    link.insertAdjacentElement('afterend', button);
  });
})();
